import type React from "react";
import { i18n } from "@frontend/i18n";

/**
 * The Suggestions tab's status line while a matching run that covers this reader
 * is queued or executing.
 *
 * Two levels of text and nothing else: no way in and no dismiss, because this
 * is the only signal that the deck under it is the previous set rather than the
 * current one.
 *
 * Deliberately independent of intake: the run behind it is queued by onboarding
 * as often as by anything a member answered, and this notice outlives the intake
 * feature that first carried one.
 */
export function SuggestionsRecalculatingNotice(): React.JSX.Element {
  return (
    <div
      className="flex w-full flex-col gap-0.5 rounded-md bg-accent p-4"
      data-testid="suggestions-recalculating-banner"
    >
      <p className="text-sm font-medium leading-tight text-foreground">
        {i18n.t("user.directory.topPicks.recalculating.title")}
      </p>
      <p className="text-sm leading-tight text-muted-foreground">
        {i18n.t("user.directory.topPicks.recalculating.subtitle")}
      </p>
    </div>
  );
}
